import Vue from 'vue'
import select from 'dom-select'
import inViewport from 'in-viewport'
import { set, tryNTimes, contains, isMobile } from 'utils/general'
import { pushDataPdpSpecifications } from 'lib/tracking'
import datalayer from 'lib/datalayer'
import { i18n } from 'lib/i18n.js'

const AGGREGATE_SELECTOR = '.yotpo-regular-box.yotpo-bottomline div.aggregated-product-related-fields'
const NEW_REVIEW_SELECTOR = '.write-first-review-button'
// Reviews
const REVIEW_BUTTON_SELECTOR = '.write-review-button'
const REVIEW_SUBMIT_BUTTON = '.submit-button input.yotpo-submit'
const REVIEW_VALUE_RADIO = ['[name="--54782"]:checked', '[name="--54763"]:checked']
const REVIEW_QUALITY_RADIO = ['[name="--54779"]:checked', '[name="--54762"]:checked']
const REVIEW_RECOMMEND_SELECT = ['[name="--54778"]', '[name="--54761"]']

function executeWhenYotpoLoads (callback, error = null) {
  const interval = setInterval(() => {
    const foundYotpo = select('.product-review__container')

    if (!foundYotpo) {
      clearInterval(interval)
      if (typeof error === 'function') error()
      return
    }

    const foundYotpoInner = select('.yotpo-regular-box', foundYotpo)
    if (foundYotpoInner) {
      if (typeof callback === 'function') callback(foundYotpo)
      clearInterval(interval)
    }
  }, 500)
}

/**
 * Checks if selector exist after yotpo has been loaded to inject class to parent
 * @param selector selector for the section/module
 * @param classToAdd class to add to the parent wrapper if module exist
 */
function addClassIfModuleExist (foundYotpo, selector, classToAdd) {
  if (!foundYotpo) return

  const foundModule = select(selector, foundYotpo)
  if (foundModule) {
    set(foundYotpo, classToAdd)
    const params = new URLSearchParams(window.location.search)
    const section = params.get('section')
    if (section === 'reviews') {
      const reviewButton = document.querySelector('#reviews .write-review-button')
      reviewButton && reviewButton.click()
    }
  }
}

function checkForAggregateModule (foundYotpo) {
  addClassIfModuleExist(foundYotpo, AGGREGATE_SELECTOR, 'has-aggregate-module')
}

function checkForNewReviewButton (foundYotpo) {
  addClassIfModuleExist(foundYotpo, NEW_REVIEW_SELECTOR, 'has-no-reviews')
}

function addSelectBoxWrappers (foundYotpo) {
  const selectBoxes = select.all('select.yotpo-single-choice-select', foundYotpo)
  selectBoxes.forEach(box => {
    const parent = box.closest('.yotpo-single-choice-field')
    if (parent) {
      set(parent, 'has-select-box')
    }
  })
}

/**
 * Sets an eventlistner to the write review button
 * @param {*} callback
 */
function whenReviewButtonClicked (callback) {
  tryNTimes(() => {
    const buttons = select.all(REVIEW_BUTTON_SELECTOR)
    if (!buttons || buttons.length === 0) return false
    buttons.forEach(btn => btn.addEventListener('click', callback))
    return true
  }, 10, 500)
}

function whenReviewSubmitButtonClicked (callback) {
  tryNTimes(() => {
    const button = select(REVIEW_SUBMIT_BUTTON)
    if (!button) return false
    button.addEventListener('click', callback)
    return true
  }, 10, 500)
}

export default el => {
  return new Vue({
    el,
    i18n,
    name: 'Product reviews',
    data: () => ({
      submittedReviewOnce: false,
      selectElement: null,
      productTitle: ''
    }),
    mounted () {
      this.productTitle = this.$el.dataset.productTitle
      executeWhenYotpoLoads((foundYotpo) => {
        checkForAggregateModule(foundYotpo)
        checkForNewReviewButton(foundYotpo)
        addSelectBoxWrappers(foundYotpo)
        this.moveSelectNextToFilterButton()
      })

      inViewport(this.$el, this.handleInViewPort)

      whenReviewButtonClicked(() => {
        whenReviewSubmitButtonClicked(() => {
          this.handleSubmitReview()
        })
      })
    },
    methods: {
      handleInViewPort () {
        pushDataPdpSpecifications({ listTitle: this.$t('products.reviews.title'), productTitle: this.productTitle })
      },
      handleSubmitReview () {
        const productValue = select(REVIEW_VALUE_RADIO[0])?.value || select(REVIEW_VALUE_RADIO[1])?.value || 0 // How would you rate the value of this product? [1-5]
        const productQuality = select(REVIEW_QUALITY_RADIO[0])?.value || select(REVIEW_QUALITY_RADIO[1])?.value || 0 // How would you rate the quality of this product? [1-5]
        let recommendToFriend = 0
        if (select(REVIEW_RECOMMEND_SELECT[0])) {
          recommendToFriend = select(REVIEW_RECOMMEND_SELECT[0]) ? (select(REVIEW_RECOMMEND_SELECT[0])?.value === 'Yes' ? 'Yes' : 'No') : '' // Would you recommend this product to a friend? [Yes, No]
        } else {
          try {
            const div = document.querySelector('.write-review')
            recommendToFriend = div.querySelectorAll('.review-star.yotpo-icon-star').length || 0
          } finally {
          }
        }
        const payload = {
          isBrandRecommended: (parseInt(productValue) + parseInt(productQuality)) / 2,
          isProductRecommended: recommendToFriend
        }
        setTimeout(() => {
          const thankYou = select('.yotpo-thank-you')
          if (!this.submittedReviewOnce && !contains(thankYou, 'yotpo-hidden')) {
            datalayer.dataLayerPush('postReview', payload)
            this.submittedReviewOnce = true

            setTimeout(() => {
              this.submittedReviewOnce = false
            }, 2000)
          }
        }, 300)
      },
      moveSelectNextToFilterButton () {
        const mobileTargetContainer = this.$el.querySelector('.mobile-more-filters-container')
        const desktopTargetContainer = this.$el.querySelector('.yotpo-nav-content')
        const selectElement = this.$el.querySelector('.yotpo-reviews-header .yotpo-drop-down-layout')

        if (isMobile()) {
          if (Boolean(mobileTargetContainer) && Boolean(selectElement)) {
            mobileTargetContainer.insertBefore(selectElement, null)
          }
        } else {
          if (Boolean(desktopTargetContainer) && Boolean(selectElement)) {
            desktopTargetContainer.insertBefore(selectElement, null)
          }
        }
      }
    }
  })
}
